import React, { useState, useEffect } from 'react';
import styles from '../../screens/FirstScreen.module.css';
import heroImg from "../../images/נטלי שוורץ מסך מרכזי.webp";
import Loader from '../../components/loader/Loader';

const HeroSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 950);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    const img = new Image();
    img.src = heroImg;
    img.onload = () => setImageLoaded(true);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  if (!imageLoaded) {
    return <Loader />;
  }

  const handleWhatsAppClick = () => {
    const phone = '972508727802';
    const message = encodeURIComponent('היי נטלי הגעתי מהדף שלך, אשמח לשמוע עוד על..');
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  return (
    <section className={styles.hero}>
      <div className={styles.decorElement3}></div>
      <div className={styles.decorElement4}></div>

      <div className={styles.container}>
        {isMobile ? (
          <>
            <div className={styles.subheadingWrapper}>
              <h2 className={styles.subheading}>
                מרגישה שהעסק שלך הרבה יותר מקצועי מאיך שהוא נראה ברשתות? העמוד הזה בשבילך.
              </h2>
            </div>

            <div className={styles.imageWrapper}>
              <img
                src={heroImg}
                alt="נטלי שוורץ - ניהול סושיאל"
                className={styles.image}
              />
            </div>

            <div className={styles.title}>
              לבנות עמוד שמחמם לידים וסוגר מכירות, כדי שתוכלי להתמקד בניהול העסק שלך
            </div>
            <div className={styles.glassContainer}>
              <p className={styles.description}>
                הגיע הזמן שהסושיאל שלך ישקף את רמת המקצועיות האמיתית שלך. ברגע שיש אסטרטגיה שיווקית שפונה בדיוק לקהל היעד שלך, יהיו לידים חמים באופן עקבי, בלי ניסוי וטעייה ובלי מרדף מתיש אחרי עריכות וטרנדים חולפים.
              </p>
            </div>

            <button className={styles.ctaButton} onClick={handleWhatsAppClick}>
              אני רוצה שהעמוד שלי יהיה מסע חימום ללקוחות שלי
            </button>
          </>
        ) : (
          <>
            <div className={styles.textContent}>
              <div className={styles.subheadingWrapper}>
                <h2 className={styles.subheading}>
                  מרגישה שהעסק שלך הרבה יותר מקצועי מאיך שהוא נראה ברשתות? העמוד הזה בשבילך.
                </h2>
              </div>

              <div className={styles.title}>
                לבנות עמוד שמחמם לידים וסוגר מכירות, כדי שתוכלי להתמקד בניהול העסק שלך
              </div>

              <div className={styles.glassContainer}>
                <p className={styles.description}>
                  הגיע הזמן שהסושיאל שלך ישקף את רמת המקצועיות האמיתית שלך. ברגע שיש אסטרטגיה שיווקית שפונה בדיוק לקהל היעד שלך, יהיו לידים חמים באופן עקבי, בלי ניסוי וטעייה ובלי מרדף מתיש אחרי עריכות וטרנדים חולפים.
                </p>
              </div>

              <button className={styles.ctaButton} onClick={handleWhatsAppClick}>
                אני רוצה שהעמוד שלי יהיה מסע חימום ללקוחות שלי
              </button>
            </div>

            <div className={styles.imageWrapper}>
              <img
                src={heroImg}
                alt="נטלי שוורץ - ניהול סושיאל"
                className={styles.image}
              />
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
